import axiosInst from "../../Config";
import { Encrypt_Value, Decrypt_Value } from "../EncryptDecrypt";

export const HealthScreeningListApi = async () => {
  const Pat_ID =
    localStorage.getItem("PID") &&
    Decrypt_Value(localStorage.getItem("PID"), "vozoportal");

  const payload = Encrypt_Value(
    {
      patient_id: Pat_ID,
      include_provider_name: 1,
    },
    "vozo",
  );

  return await axiosInst.post(
    `/vozo/patient/preventive-screenings/list`,
    payload,
  );
};
